import * as React from 'react';
import { TextButton } from '@wix/design-system';
import { Brands } from 'enums';
import { useTranslation } from 'react-i18next';

export enum FooterLinkCode {
  TERMS_OF_USE = 'terms_of_use',
  PRIVACY = 'privacy',
  CONTACT_US = 'contact_us',
}

const FooterLinkHrefByBrand = {
  [Brands.WIX]: {
    [FooterLinkCode.TERMS_OF_USE]:
      'https://www.wix.com/about/terms-of-use?referralAdditionalInfo=realDeal',
    [FooterLinkCode.PRIVACY]:
      'https://www.wix.com/about/privacy?referralAdditionalInfo=realDeal',
    [FooterLinkCode.CONTACT_US]:
      'https://www.wix.com/about/contact-us?referralAdditionalInfo=realDeal',
  },
  [Brands.EDITOR_X]: {
    [FooterLinkCode.TERMS_OF_USE]: 'https://www.editorx.com/info/terms-of-use',
    [FooterLinkCode.PRIVACY]: 'https://www.editorx.com/info/privacy',
    [FooterLinkCode.CONTACT_US]: 'https://www.wix.com/about/contact-us',
  },
  [Brands.DAYFUL]: {
    // TODO - Fix links once the dayful domain launches
    [FooterLinkCode.TERMS_OF_USE]: 'https://www.editorx.com/info/terms-of-use',
    [FooterLinkCode.PRIVACY]: 'https://www.editorx.com/info/privacy',
    [FooterLinkCode.CONTACT_US]: 'https://www.wix.com/about/contact-us',
  },
  studio: {
    [FooterLinkCode.TERMS_OF_USE]: 'https://www.wix.com/about/terms-of-use',
    [FooterLinkCode.PRIVACY]: 'https://www.wix.com/about/privacy',
    [FooterLinkCode.CONTACT_US]: 'https://www.wix.com/about/contact-us',
  },
};

export const FooterLink = ({ brand, code }) => {
  const { t } = useTranslation();
  return (
    <TextButton
      dataHook={`footer-${code}`}
      size='small'
      as='a'
      target='_blank'
      skin='dark'
      href={FooterLinkHrefByBrand[brand][code]}
    >
      {t(`footer.${code}.text`)}
    </TextButton>
  );
};
